import React from 'react';
import { View, Text, Switch, StyleSheet } from 'react-native';
import { useThemedStyles, useThemeColors } from '@/hooks/residents/useThemeColors';

type Props = {
  label: string;
  subtitle?: string;
  value: boolean;
  onChange: (v: boolean) => void;
};

function useStyles() {
  return useThemedStyles(({ colors }) =>
    StyleSheet.create({
      toggleRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: colors.text.subtle },
      toggleCopy: { flex: 1, paddingRight: 12 },
      toggleLabel: { color: colors.text.primary, fontSize: 16, fontWeight: '700' },
      toggleSub: { color: colors.text.subtle, fontSize: 14 },
    }),
  );
}

export const NotificationToggleRow: React.FC<Props> = ({ label, subtitle, value, onChange }) => {
  const styles = useStyles();
  const { components } = useThemeColors();

  return (
    <View style={styles.toggleRow}>
      <View style={styles.toggleCopy}>
        <Text style={styles.toggleLabel}>{label}</Text>
        {!!subtitle && <Text style={styles.toggleSub}>{subtitle}</Text>}
      </View>
      <Switch
        value={value}
        onValueChange={onChange}
        trackColor={{ false: components.toggle.trackOff, true: components.toggle.trackOn }}
        thumbColor={components.toggle.thumb}
      />
    </View>
  );
};

export default NotificationToggleRow;
